import { lazy } from 'react';
import { Switch } from 'react-router-dom';
import { ProtectedRoute, Route } from '@client/components/common/Route';

const ConnectLoader = lazy(() => import('@client/components/routes/Connect'));
const ConnectDetailsLoader = lazy(() => import('@client/components/routes/Connect/Details'));

// Below routes are activated when the user creates a new profile from a show call
const ConnectCreateHostLoader = lazy(() => import('@client/components/routes/Connect/Details/CreateHost'));
const ConnectCreateArtistLoader = lazy(() => import('@client/components/routes/Connect/Details/CreateArtist'));

// Below routes are activated when the user signs up for an account from a show call
const ConnectCreateHostSignupLoader = lazy(() => import('@client/components/routes/Connect/Details/CreateHostSignup'));
const ConnectCreateArtistSignupLoader = lazy(() => import('@client/components/routes/Connect/Details/CreateArtistSignup'));

// Below routes are activated when the user completes their profile from a show call
const ConnectCompleteProfileLoader = lazy(() => import('@client/components/routes/Connect/Details/CompleteProfile'));

export default () => (
  <Switch>
    <Route
      exact
      path={['/connect', '/connect/hosts', '/connect/artists']}
      load={ConnectLoader}
    />

    <ProtectedRoute
      exact
      path="/connect/:showCallId/host"
      load={ConnectCreateHostLoader}
    />

    <ProtectedRoute
      exact
      path="/connect/:showCallId/artist"
      load={ConnectCreateArtistLoader}
    />

    <ProtectedRoute
      path="/connect/:showCallId/host/:step"
      load={ConnectCreateHostSignupLoader}
    />

    <ProtectedRoute
      path="/connect/:showCallId/artist/:step"
      load={ConnectCreateArtistSignupLoader}
    />

    <ProtectedRoute
      exact
      path="/connect/:showCallId/complete"
      load={ConnectCompleteProfileLoader}
    />

    <Route
      exact
      path="/connect/:showCallId"
      load={ConnectDetailsLoader}
    />
  </Switch>
);
